import Vue from 'vue'
import modal from './modal/index'
import layoutModal from './modal/layout'
import modalRelatorios from './modal/relatorios'
import completeGrid from './completeGrid'
import fieldBusca from './fieldBusca'
import autoCompleteBusca from './autoCompleteBusca'
import fieldCheckBox from './fieldCheckbox'
import acaoForm from './acaoForm'
import gridForm from './gridForm/'
import stReport from './stReport'
import stDesigner from './stDesigner'
// Groups
import './simple-crud'

// UI
Vue.component('ui-modal', modal)
Vue.component('ui-layout-modal', layoutModal)
Vue.component('ui-modal-relatorios', modalRelatorios)
Vue.component('ui-complete-grid', completeGrid)
Vue.component('ui-field-busca', fieldBusca)
Vue.component('ui-field-checkbox', fieldCheckBox)
Vue.component('ui-auto-complete-busca', autoCompleteBusca)
Vue.component('ui-acao-form', acaoForm)
Vue.component('ui-grid-form', gridForm)
Vue.component('ui-st-report', stReport)
Vue.component('ui-st-designer', stDesigner)
